module.exports = __webpack_public_path__ + "img/1474940144.ea3b2c38.jpg";